import React, { useState, useEffect } from "react";
import {
    Button,
    Container,
    Row,
    Col,
    Card,
    CardHeader,
    CardBody,
    Input,
    Table,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Form,
    FormGroup,
    Label,
    Spinner,
} from "reactstrap";
import { toast } from "react-toastify";
import {
    FaPencilAlt,
    FaTrash,
    FaPlus,
    FaEye,
} from "react-icons/fa";
import { apiURL1 } from "../../config";
import axios from "axios";
import Footer from 'components/Footers/Footer';


const CustomTable = ({ columns, data }) => {
    return (
        <Table responsive>
            <thead>
                <tr>
                    {columns &&
                        columns.map((column, index) => <th key={index}>{column}</th>)}
                </tr>
            </thead>
            <tbody>
                {data && data.length > 0 ? (
                    data.map((row, rowIndex) => (
                        <tr key={rowIndex}>
                            {columns.map((column, colIndex) => (
                                <td key={colIndex}>
                                    {column.toLowerCase() === "actions" ? (
                                        row.actions
                                    ) : (
                                        row[column.toLowerCase().replace(/ /g, "")]
                                    )}
                                </td>
                            ))}
                        </tr>
                    ))
                ) : (
                    <tr>
                        <td colSpan={columns.length} className="text-center">
                            No data available
                        </td>
                    </tr>
                )}
            </tbody>
        </Table>
    );
};

const DonationCategory = () => {
    const token = localStorage.getItem("token");

    const [donationCategories, setDonationCategories] = useState([]);
    const [newDonationCategoryName, setNewDonationCategoryName] = useState("");
    const [editDonationCategoryId, setEditDonationCategoryId] = useState(null);
    const [editDonationCategoryName, setEditDonationCategoryName] = useState("");
    const [searchQuery, setSearchQuery] = useState("");
    const [modalOpen, setModalOpen] = useState(false);
    const [editModalOpen, setEditModalOpen] = useState(false);
    const [deleteModalOpen, setDeleteModalOpen] = useState(false);
    const [deleteDonationCategoryId, setDeleteDonationCategoryId] = useState(
        null
    );
    const baseURL = apiURL1;
    const [loading, setLoading] = useState(false);
    const [viewModalOpen, setViewModalOpen] = useState(false);
    const [donationDetails, setDonationDetails] = useState([]);

    useEffect(() => {
        fetchDonationCategories();
    }, []);

    const fetchDonationCategories = async () => {
        try {
            setLoading(true);
            const response = await axios.get(
                `${baseURL}/superadmin/getAllDonationCategoriesSummary?pag=1&limit=10`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            // console.log("API Response:", response.data);
            if (response.data && response.data.success) {
                setDonationCategories(response.data.data.donationCategoriesSummary);
            } else {
                setDonationCategories([]);
                toast.error("Failed to fetch donation categories.");
            }
        } catch (error) {
            console.error("Error fetching donation categories:", error);
            toast.error("Error fetching donation categories!");
            setDonationCategories([]);
        } finally {
            setLoading(false);
        }
    };

    const handleAddDonationCategory = async (e) => {
        e.preventDefault();
        try {
            const response = await axios.post(
                `${baseURL}/superadmin/donation-categories`,
                { name: newDonationCategoryName },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }
            );
            if (response.status === 201) {
                toast.success("Donation category added successfully!");
                fetchDonationCategories();
                setNewDonationCategoryName("");
                setModalOpen(false);
            } else {
                toast.error("Error adding donation category!");
            }
        } catch (error) {
            console.error("Error adding donation category:", error);
            toast.error("Error adding donation category!");
        }
    };

    const handleEditDonationCategory = (donationCategory) => {
        setEditDonationCategoryId(donationCategory.categoryId);
        setEditDonationCategoryName(donationCategory.categoryName);
        setEditModalOpen(true);
    };

    const handleUpdateDonationCategory = async (e) => {
        e.preventDefault();
        try {
            const response = await axios.put(
                `${baseURL}/superadmin/donation-categories/${editDonationCategoryId}`,
                { name: editDonationCategoryName },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }
            );
            if (response.status === 200) {
                toast.success("Donation category updated successfully!");
                fetchDonationCategories();
                setEditDonationCategoryId(null);
                setEditDonationCategoryName("");
                setEditModalOpen(false);
            } else {
                toast.error("Error updating donation category!");
            }
        } catch (error) {
            console.error("Error updating donation category:", error);
            toast.error("Error updating donation category!");
        }
    };

    const handleDeleteDonationCategory = (id) => {
        setDeleteDonationCategoryId(id);
        setDeleteModalOpen(true);
    };

    const confirmDeleteDonationCategory = async () => {
        try {
            const response = await axios.delete(
                `${baseURL}/superadmin/donation-categories/${deleteDonationCategoryId}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            if (response.status === 200) {
                toast.success("Donation category deleted successfully!");
                fetchDonationCategories();
            } else {
                toast.error("Error deleting donation category!");
            }
        } catch (error) {
            console.error("Error deleting donation category:", error);
            toast.error("Error deleting donation category!");
        } finally {
            setDeleteModalOpen(false);
            setDeleteDonationCategoryId(null);
        }
    };

    const filteredDonationCategories = donationCategories
        ? donationCategories.filter((donationCategory) =>
            donationCategory.categoryName
                .toLowerCase()
                .includes(searchQuery.toLowerCase())
        )
        : [];

    // console.log('filteredDonationCategories is ', filteredDonationCategories)
    const handleViewDonations = (donations) => {
        setDonationDetails(donations);
        setViewModalOpen(true);
    };

    const columns = ["Name", "Amount", "Actions"];

    return (
        <>
            <div
                className="header   d-flex align-items-center"
                style={{
                    minHeight: "600px",
                    backgroundImage:
                        "url(" + require("../../assets/img/theme/alRehman.jpg") + ")",
                    backgroundSize: "cover",
                    backgroundPosition: "center top",
                }}
            >
                <span className="mask bg-gradient-default opacity-8" />
                <Container className="d-flex align-items-center" fluid>
                    <Row>
                        <Col lg="7" md="10">
                            <h1 className="display-4 text-white">Donation Categories</h1>
                            <p className="text-white mt-0 mb-5">
                                Manage donation categories for your organization.
                            </p>
                        </Col>
                    </Row>
                </Container>
            </div>
            <Container className="mt--7" fluid>
                <Row>
                    <Col>
                        <Card className="shadow">
                            <CardHeader className="border-0 d-flex justify-content-between align-items-center">
                                <h3 className="mb-0">Donation Categories</h3>
                                <div>
                                    <Input
                                        type="text"
                                        placeholder="Search donation categories..."
                                        value={searchQuery}
                                        onChange={(e) => setSearchQuery(e.target.value)}
                                        style={{
                                            marginRight: "10px",
                                            display: "inline-block",
                                            width: "200px",
                                        }}
                                    />
                                    <Button color="primary" onClick={() => setModalOpen(true)}>
                                        <FaPlus /> Add New
                                    </Button>
                                </div>
                            </CardHeader>
                            <CardBody>
                                {loading ? (
                                    <Spinner />
                                ) : (
                                    <CustomTable
                                        columns={columns}
                                        data={
                                            filteredDonationCategories
                                                ? filteredDonationCategories.map((category) => ({
                                                    name: category.categoryName,
                                                    amount: category.totalDonationAmount,
                                                    actions: (
                                                        <>
                                                            <Button
                                                                color="info"
                                                                size="sm"
                                                                onClick={() => handleEditDonationCategory(category)}
                                                            >
                                                                <FaPencilAlt />
                                                            </Button>
                                                            <Button
                                                                color="danger"
                                                                size="sm"
                                                                onClick={() =>
                                                                    handleDeleteDonationCategory(category.categoryId)
                                                                }
                                                            >
                                                                <FaTrash />
                                                            </Button>
                                                            <Button
                                                                color="primary"
                                                                size="sm"
                                                                onClick={() =>
                                                                    handleViewDonations(category.overallDonations)
                                                                }
                                                            >
                                                                <FaEye />
                                                            </Button>
                                                        </>
                                                    ),
                                                }))
                                                : []
                                        }
                                    />
                                )}
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
            <Modal isOpen={modalOpen} toggle={() => setModalOpen(false)}>
                <ModalHeader toggle={() => setModalOpen(false)}>
                    Add New Donation Category
                </ModalHeader>
                <ModalBody>
                    <Form onSubmit={handleAddDonationCategory}>
                        <FormGroup>
                            <Label for="donationCategoryName">Name</Label>
                            <Input
                                type="text"
                                id="donationCategoryName"
                                placeholder="Enter donation category name"
                                value={newDonationCategoryName}
                                onChange={(e) => setNewDonationCategoryName(e.target.value)}
                            />
                        </FormGroup>
                        <Button color="primary" type="submit">
                            Add
                        </Button>
                    </Form>
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={() => setModalOpen(false)}>
                        Cancel
                    </Button>
                </ModalFooter>
            </Modal>
            <Modal isOpen={editModalOpen} toggle={() => setEditModalOpen(false)}>
                <ModalHeader toggle={() => setEditModalOpen(false)}>
                    Edit Donation Category
                </ModalHeader>
                <ModalBody>
                    <Form onSubmit={handleUpdateDonationCategory}>
                        <FormGroup>
                            <Label for="editDonationCategoryName">Name</Label>
                            <Input
                                type="text"
                                id="editDonationCategoryName"
                                placeholder="Enter donation category name"
                                value={editDonationCategoryName}
                                onChange={(e) => setEditDonationCategoryName(e.target.value)}
                            />
                        </FormGroup>
                        <Button color="primary" type="submit">
                            Update Donation Category
                        </Button>
                    </Form>
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={() => setEditModalOpen(false)}>
                        Cancel
                    </Button>
                </ModalFooter>
            </Modal>
            <Modal isOpen={deleteModalOpen} toggle={() => setDeleteModalOpen(false)}>
                <ModalHeader toggle={() => setDeleteModalOpen(false)}>
                    Delete Donation Category
                </ModalHeader>
                <ModalBody>
                    <p>Are you sure you want to delete this donation category?</p>
                </ModalBody>
                <ModalFooter>
                    <Button color="danger" onClick={confirmDeleteDonationCategory}>
                        Yes, Delete
                    </Button>
                    <Button color="secondary" onClick={() => setDeleteModalOpen(false)}>
                        Cancel
                    </Button>
                </ModalFooter>
            </Modal>

            <Modal isOpen={viewModalOpen} toggle={() => setViewModalOpen(false)}>
                <ModalHeader toggle={() => setViewModalOpen(false)}>
                    Donation Details
                </ModalHeader>
                <ModalBody>
                    {donationDetails && donationDetails.length > 0 ? (
                        <Table responsive>
                            <thead>
                                <tr>
                                    <th>Name</th>
                                    <th>Amount</th>
                                    <th>Date</th>
                                    <th>Purpose</th>
                                    <th>Donor Name</th>
                                </tr>
                            </thead>
                            <tbody>
                                {donationDetails.map((donation) => (
                                    <tr key={donation._id}>
                                        <td>{donation.donationName}</td>
                                        <td>{donation.amount}</td>
                                        <td>
                                            {(() => {
                                                const d = new Date(donation.date);
                                                const day = String(d.getDate()).padStart(2, '0');
                                                const month = String(d.getMonth() + 1).padStart(2, '0');
                                                const year = d.getFullYear();
                                                return `${day}-${month}-${year}`;
                                            })()}
                                        </td>
                                        <td>{donation.purpose}</td>
                                        <td>{donation.donorName}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    ) : (
                        <p>No donations available for this category.</p>
                    )}
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={() => setViewModalOpen(false)}>
                        Close
                    </Button>
                </ModalFooter>
            </Modal>
            <Footer />
        </>
    );
};

export default DonationCategory;
